import { AxisSide, type AxisSpec } from "../../ChartSpec";
import type { GetDisplayInfo } from "../../units/use-get-display-info";
import { UnitBadge } from "./unit-badge";

const UNIT_BADGE_SIDES = [AxisSide.Left, AxisSide.Right] as const;

function findAxisForSide(
    side: AxisSpec["side"],
    axes: AxisSpec[],
    activeLeftAxisId: string | undefined,
): AxisSpec | undefined {
    if (side === AxisSide.Left) {
        return axes.find((candidate) => candidate.id === activeLeftAxisId) ?? axes.find((a) => a.side === side);
    }
    return axes.find((candidate) => candidate.side === side);
}

export function UnitBadges({
    axes,
    getDisplayInfo,
    activeLeftAxisId,
    leftAxes,
    onActiveLeftAxisChange,
}: {
    axes: AxisSpec[];
    getDisplayInfo: GetDisplayInfo;
    activeLeftAxisId: string | undefined;
    leftAxes: AxisSpec[];
    onActiveLeftAxisChange: (axisId: string) => void;
}) {
    return (
        <>
            {UNIT_BADGE_SIDES.map((side) => {
                const axis = findAxisForSide(side, axes, activeLeftAxisId);
                if (!axis) return null;

                const displayInfo = getDisplayInfo(axis.unitCategory);
                const label = axis.label ?? (displayInfo.isKnown ? displayInfo.symbol : axis.unitCategory);

                return (
                    <UnitBadge
                        key={side}
                        label={label}
                        side={side}
                        unitCategory={axis.unitCategory}
                        currentUnit={displayInfo.unit}
                        clickable={displayInfo.isKnown}
                        axisCandidates={side === AxisSide.Left ? leftAxes : []}
                        activeAxisId={side === AxisSide.Left ? activeLeftAxisId : undefined}
                        onActiveAxisChange={side === AxisSide.Left ? onActiveLeftAxisChange : undefined}
                    />
                );
            })}
        </>
    );
}
